<template>
  <div class="cleaning-stats-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>清运员统计</span>
      </div>
      <div class="toolbar">
        <el-radio-group v-model="preset" size="small" @change="handlePresetChange" style="margin-right: 10px">
          <el-radio-button label="today">本日</el-radio-button>
          <el-radio-button label="week">本周</el-radio-button>
          <el-radio-button label="month">本月</el-radio-button>
          <el-radio-button label="year">本年</el-radio-button>
          <el-radio-button label="custom">自定义</el-radio-button>
        </el-radio-group>
        
        <el-date-picker
          v-model="startTime"
          type="datetime"
          size="small"
          placeholder="开始时间"
          style="width: 200px"
          @change="handleDateChange"
        />
        <span style="margin: 0 10px; color: #606266">至</span>
        <el-date-picker
          v-model="endTime"
          type="datetime"
          size="small"
          placeholder="结束时间"
          style="width: 200px"
          @change="handleDateChange"
        />
        
        <el-select v-model="operator" size="small" placeholder="清运员" style="margin-left:10px;width:180px" filterable clearable>
          <el-option v-for="o in operatorOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
        <el-button size="small" type="primary" style="margin-left:10px" @click="fetchData">筛选</el-button>
        <el-button size="small" style="margin-left:10px" @click="exportCSV">导出</el-button>
      </div>

      <div class="summary">
        清运量统计：<b>{{ formatNumber(totalWeight) }}</b> kg
        清运次数统计：<b>{{ formatNumber(totalTimes) }}</b> 次
        清运支付金额：<b>{{ formatNumber(totalAmount) }}</b>
      </div>

      <div ref="chart" class="chart"></div>
    </el-card>

    <el-card class="box-card" style="margin-top: 16px;">
      <el-table ref="table" :data="tableData" height="520" border style="width: 100%;">
        <el-table-column prop="time" label="日期" :width="colWidth" />
        <el-table-column prop="cleanerName" label="清运员姓名" :width="colWidth" />
        <el-table-column prop="times" label="清运次数(次)" :width="colWidth" />
        <el-table-column prop="weight" label="清运重量(Kg)" :width="colWidth" />
        <el-table-column prop="amount" label="清运支付金额" :width="colWidth" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getCleanerStatistics } from '@/api/statistics'
import { getUserList } from '@/api/users'

export default {
  name: 'CleanerStats',
  data() {
    return {
      preset: 'today',
      startTime: null,
      endTime: null,
      operator: '',
      operatorOptions: [{ label: '全部', value: '' }],
      totalWeight: 0,
      totalTimes: 0,
      totalAmount: 0,
      tableData: [],
      colWidth: 200,
      chartInstance: null
    }
  },
  mounted() {
    this.initPreset()
    this.initChart()
    this.fetchOperators()
    this.fetchData()
    this.$nextTick(() => { this.updateColWidth(); window.addEventListener('resize', this.updateColWidth) })
  },
  beforeDestroy() { window.removeEventListener('resize', this.updateColWidth) },
  methods: {
    handlePresetChange(val) {
      if (val === 'custom') return
      this.initPreset()
      this.fetchData()
    },
    handleDateChange() {
      this.preset = 'custom'
    },
    async fetchOperators() {
      try {
        const res = await getUserList({ page: 1, page_size: 100, role: 1 })
        const data = res && res.data ? res.data : res
        const users = Array.isArray(data && data.users) ? data.users : []
        const opts = [{ label: '全部', value: '' }].concat(users.map(u => ({ label: u.real_name || u.cleaner_name || `ID:${u.id}`, value: u.id })))
        this.operatorOptions = opts
      } catch (e) {
        this.operatorOptions = [{ label: '全部', value: '' }]
      }
    },
    getCompanyId() {
      const s = this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.userInfo
      const fromStore = (s && s.company_id) || ''
      const fromLocal = localStorage.getItem('company_id') || ''
      return fromStore || fromLocal || ''
    },
    formatNumber(n) {
      if (n === null || n === undefined || n === '') return '0'
      const num = Number(n)
      if (Number.isNaN(num)) return String(n)
      return String(Math.trunc(num))
    },
    formatDateTime(d, endOfDay = false) {
      const dt = new Date(d)
      if (!(dt instanceof Date) || isNaN(dt.getTime())) return ''
      const y = dt.getFullYear()
      const m = String(dt.getMonth() + 1).padStart(2, '0')
      const day = String(dt.getDate()).padStart(2, '0')
      const h = endOfDay ? '23' : String(dt.getHours()).padStart(2, '0')
      const min = endOfDay ? '59' : String(dt.getMinutes()).padStart(2, '0')
      const s = endOfDay ? '59' : String(dt.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${min}:${s}`
    },
    formatDateOnly(d) {
      const dt = new Date(d)
      if (!(dt instanceof Date) || isNaN(dt.getTime())) return ''
      const y = dt.getFullYear()
      const m = String(dt.getMonth() + 1).padStart(2, '0')
      const day = String(dt.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    initPreset() {
      if (this.preset === 'today') {
        this.startTime = new Date(new Date().setHours(0, 0, 0, 0))
        this.endTime = new Date()
      } else if (this.preset === 'week') {
        const d = new Date()
        const day = d.getDay() || 7
        d.setHours(0, 0, 0, 0)
        d.setDate(d.getDate() - day + 1)
        this.startTime = d
        this.endTime = new Date()
      } else if (this.preset === 'month') {
        const d = new Date()
        d.setDate(1)
        d.setHours(0, 0, 0, 0)
        this.startTime = d
        this.endTime = new Date()
      } else if (this.preset === 'year') {
        const d = new Date()
        d.setMonth(0)
        d.setDate(1)
        d.setHours(0, 0, 0, 0)
        this.startTime = d
        this.endTime = new Date()
      }
    },
    updateColWidth() {
      const containerWidth = this.$refs.table ? this.$refs.table.$el.clientWidth : 800
      const cols = 5
      this.colWidth = Math.max(160, Math.floor(containerWidth / cols) - 20)
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
    },
    buildChartOption(labels, series) {
      return {
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: labels },
        yAxis: { type: 'value' },
        series: [{ data: series, type: 'line', smooth: true }]
      }
    },
    escapeCSV(val) {
      const s = String(val || '')
      if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`
      return s
    },
    exportCSV() {
      const headers = ['日期', '清运员姓名', '清运次数(次)', '清运重量(Kg)', '清运支付金额']
      const rows = this.tableData.map(r => [r.time, r.cleanerName, r.times, r.weight, r.amount])
      const totalRow = ['合计', '', this.formatNumber(this.totalTimes), this.formatNumber(this.totalWeight), this.formatNumber(this.totalAmount)]
      const lines = [
        headers.join(','),
        ...rows.map(a => a.map(v => this.escapeCSV(v)).join(',')),
        totalRow.map(v => this.escapeCSV(v)).join(',')
      ]
      const bom = '\ufeff'
      const csvContent = bom + lines.join('\r\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const from = this.formatDateTime(new Date(this.startTime || new Date()), false)
      const to = this.formatDateTime(new Date(this.endTime || new Date()), true)
      const filename = `清运员统计_${from.replace(/[:\s]/g, '-')}_${to.replace(/[:\s]/g, '-')}.csv`
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    normalizeRow(row) {
      const d = row.date || row.time || row.hour || row.label || ''
      const time = typeof d === 'string' && d.includes(' ') ? d.split(' ')[1] : d
      const times = row.cleaning_times || row.times || row.count || 0
      const weight = row.cleaning_weight || row.weight || 0
      const amount = row.payment_amount || row.cleaning_amount || row.amount || row.money || 0
      
      let cleanerName = row.cleaner_name || row.user_name || row.real_name || row.name || ''
      if (!cleanerName && this.operator) {
        const op = this.operatorOptions.find(o => o.value === this.operator)
        if (op) cleanerName = op.label
      }
      
      return { 
        time, 
        cleanerName, 
        times: Number(times) || 0, 
        weight: Number(weight) || 0, 
        amount: Number(amount) || 0 
      }
    },
    async fetchData() {
      try {
        const companyId = this.getCompanyId()
        if (!companyId) return
        const from = this.formatDateOnly(new Date(this.startTime || new Date()))
        const to = this.formatDateOnly(new Date(this.endTime || new Date()))
        const params = { company_id: companyId, from, to }
        if (this.operator) params.user_id = this.operator
        const res = await getCleanerStatistics(params)
        const body = res && res.data ? res.data : res
        const arr = Array.isArray(body.details) ? body.details : []
        const rows = arr.map(this.normalizeRow)
        this.tableData = rows
        this.totalTimes = Number(body.total_times) || rows.reduce((s, r) => s + (Number(r.times) || 0), 0)
        this.totalWeight = Number(body.total_weight) || rows.reduce((s, r) => s + (Number(r.weight) || 0), 0)
        this.totalAmount = Number(body.total_payment_amount) || rows.reduce((s, r) => s + (Number(r.amount) || 0), 0)
        const labels = rows.map(r => r.time)
        const series = rows.map(r => Math.trunc(Number(r.weight || 0)))
        const option = this.buildChartOption(labels, series)
        this.chartInstance && this.chartInstance.setOption(option)
      } catch (e) {
        const labels = []
        const series = []
        const option = this.buildChartOption(labels, series)
        this.chartInstance && this.chartInstance.setOption(option)
      }
    }
  }
}
</script>

<style scoped>
.cleaning-stats-container { padding: 20px; }
.box-card { border: none; border-radius: 8px; }
.toolbar { display: flex; align-items: center; flex-wrap: wrap; }
.summary { margin: 10px 0 6px; color: #606266; }
.summary b { color: #303133; margin: 0 4px; }
.chart { width: 100%; height: 420px; }
</style>
